import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
// 该 js 最好在页面加载最早时机执行
var WH = function WH() {
  return typeof window === 'undefined' ? 0 : window.innerHeight;
};
var CHECK_INTERVAL = 500;
var TIME_OUT = 1e4;
var MarkState = {
  START: 'start',
  COMPLETE: 'readyState',
  LOAD: 'load',
  TOUCH: 'touch',
  BEFOREUNLOAD: 'beforeunload',
  TIMEOUT: 'timeout'
};
var SCORE_ITEMS = [];
export var observer;
var calculateScore = function calculateScore(el, tiers, parentScore) {
  try {
    var score = 0;
    var tagName = el.tagName;
    if ('SCRIPT' !== tagName && 'STYLE' !== tagName && 'META' !== tagName && 'HEAD' !== tagName) {
      var childrenLen = el.children ? el.children.length : 0;
      if (childrenLen > 0) {
        for (var child = el.children, len = childrenLen - 1; len >= 0; len--) {
          score += calculateScore(child[len], tiers + 1, score > 0);
        }
      }
      if (score <= 0 && !parentScore) {
        if (!(el.getBoundingClientRect && el.getBoundingClientRect().top < WH())) return 0;
      }
      score += 1 + 0.5 * tiers;
    }
    return score;
  } catch (error) {}
};
var getFmp = function getFmp(scoreArr) {
  // 过滤掉 score[n] < score[n-1] 的元素
  try {
    for (var n = 1; n < scoreArr.length; n++) {
      if (scoreArr[n].score < scoreArr[n - 1].score) {
        scoreArr.splice(n, 1);
        return getFmp(scoreArr);
      }
    }
    return scoreArr;
  } catch (error) {}
};
var FMPTiming = /*#__PURE__*/function () {
  function FMPTiming(_ref) {
    var callback = _ref.callback,
      _ref$startTime = _ref.startTime,
      startTime = _ref$startTime === void 0 ? 0 : _ref$startTime;
    _classCallCheck(this, FMPTiming);
    _defineProperty(this, "timer", void 0);
    _defineProperty(this, "touchEvent", void 0);
    _defineProperty(this, "observer", void 0);
    _defineProperty(this, "mark", void 0);
    _defineProperty(this, "callback", void 0);
    _defineProperty(this, "startTime", void 0);
    _defineProperty(this, "beforeunloadEvent", void 0);
    _defineProperty(this, "timeoutTimer", void 0);
    _defineProperty(this, "isFinished", void 0);
    this.callback = callback;
    this.startTime = startTime;
    this.observer = null;
    this.isFinished = false;
    this.mark = MarkState.START;
    this.initObserver();
  }
  _createClass(FMPTiming, [{
    key: "supportTiming",
    value: function supportTiming() {
      try {
        if (performance && performance.timing && typeof MutationObserver !== 'undefined') {
          return true;
        } else {
          console.error('WARN: 当前环境不支持 performance API，请忽略！');
          return false;
        }
      } catch (err) {
        // console.error(err)
        return false;
      }
    }
  }, {
    key: "initObserver",
    value: function initObserver() {
      var _this = this;
      try {
        if (!this.supportTiming()) return;
        // 重置状态
        this.resetState();
        // LogInfo('fmp 开始监听元素')
        observer = this.observer = new MutationObserver(function () {
          var time = Date.now() - _this.startTime;
          var bodyTarget = document.body;
          if (bodyTarget) {
            var score = 0;
            score += calculateScore(bodyTarget, 1, false);
            SCORE_ITEMS.push({
              score: score,
              t: time
            });
          } else {
            SCORE_ITEMS.push({
              score: 0,
              t: time
            });
          }
        });
        this.observer.observe(document, {
          childList: true,
          subtree: true
        });
        this.timeoutTimer = setTimeout(function () {
          if (_this.isFinished) return;
          _this.mark = MarkState.TIMEOUT;
          _this.calFinallyScore();
        }, TIME_OUT);
        this.beforeunloadEvent = this.beforeunloadHandle.bind(this);
        window.addEventListener(
        // 页面关闭
        'beforeunload', this.beforeunloadEvent, true);
        this.touchEvent = this.listenMouseDown.bind(this);
        window.addEventListener('mousedown', this.touchEvent, true);
      } catch (error) {}
      return this;
    }
  }, {
    key: "beforeunloadHandle",
    value: function beforeunloadHandle() {
      this.mark = MarkState.BEFOREUNLOAD;
      this.calFinallyScore();
    }
  }, {
    key: "listenMouseDown",
    value: function listenMouseDown() {
      // 触摸事件
      var delayTime = 0;
      delayTime = Date.now() - this.startTime;
      // console.log('listenMouseDown delayTime', delayTime, this.startTime, Date.now())
      if (+delayTime > 500) {
        this.mark = MarkState.TOUCH;
        this.calFinallyScore();
        window.removeEventListener('mousedown', this.touchEvent, true);
      }
    }
  }, {
    key: "resetState",
    value: function resetState() {
      observer && observer.disconnect();
      SCORE_ITEMS = [];
      this.timer && clearTimeout(this.timer);
      this.touchEvent && window.removeEventListener('mousedown', this.touchEvent, true);
      this.beforeunloadEvent && window.removeEventListener('beforeunload', this.beforeunloadEvent, true);
    }
  }, {
    key: "calFinallyScore",
    value: function calFinallyScore() {
      var _this2 = this;
      try {
        var time = Date.now() - this.startTime;
        var isCheckFmp = time > TIME_OUT ||
        // 10秒超时时间
        SCORE_ITEMS && SCORE_ITEMS.length > 4 && time - (SCORE_ITEMS && SCORE_ITEMS.length && SCORE_ITEMS[SCORE_ITEMS.length - 1].t || 0) > 2 * CHECK_INTERVAL ||
        // 最少4 个 SCORE_ITEMS 元素  & 当前时间 - 最后一个 SCORE_ITEMS 元素渲染时间差 > 2 * 500 两次 calFinallyScore 执行时间
        // 说明到达了 元素不再变化的时间点
        SCORE_ITEMS.length > 10 && window.performance.timing.loadEventEnd !== 0 && SCORE_ITEMS[SCORE_ITEMS.length - 1].score === SCORE_ITEMS[SCORE_ITEMS.length - 9].score;
        // SCORE_ITEMS 元素大于 10 个 & load 结束 & SCORE_ITEMS 最后一个元素的分数 为 倒数第9个元素分数 ？？
        // 说明load 结束并且 dom 不再变化

        // console.log('this.observer && isCheckFmp', this.observer && isCheckFmp)
        if (this.observer && isCheckFmp) {
          this.observer.disconnect(); // 取消 MutationObserver
          this.timeoutTimer && clearTimeout(this.timeoutTimer); // 清 timeout
          window.SCORE_ITEMS_CHART = JSON.parse(JSON.stringify(SCORE_ITEMS));
          // console.log('SCORE_ITEMS_CHART', window.SCORE_ITEMS_CHART, SCORE_ITEMS);
          var fmps = getFmp(SCORE_ITEMS);
          var record = null;
          for (var o = 1; o < fmps.length; o++) {
            if (fmps[o].t >= fmps[o - 1].t) {
              var l = fmps[o].score - fmps[o - 1].score
              // 计算出分数变化最大时的时间点 record.t = fmps[o].t
              ;
              (!record || record.rate <= l) && (record = {
                t: fmps[o].t,
                rate: l
              });
            }
          }
          // 取fmp的时间，默认是10001 大于10s会自动被过滤
          var fmp = record && record.t || 10001;
          try {
            //
            if (this.isFinished) return;
            this.isFinished = true;
            this.callback({
              value: Math.min(parseInt(fmp, 10), 10001),
              type: 'fmp'
            });
            this.timer && clearTimeout(this.timer);
          } catch (error) {
            this.timer && clearTimeout(this.timer);
          }
        } else {
          this.timer && clearTimeout(this.timer);
          this.timer = setTimeout(function () {
            _this2.calFinallyScore();
          }, CHECK_INTERVAL);
        }
      } catch (error) {}
    }
  }]);
  return FMPTiming;
}();
export { FMPTiming as default };